import { Dialog, DialogBody, DialogHeader } from '@ui/dialog'
import { observer } from 'mobx-react-lite'

import { useAppStore } from '@/entities/app-store'
import { useStore } from '../../hooks/use-store'
import { getData } from '../../lib/get-data'
import { getLink, type SocialType } from '../../lib/get-link'
import { IconButton } from '../icon-buton'

export const Modal = observer(() => {
  const appStore = useAppStore()
  const { modal } = useStore
  const user = appStore.appState.user

  if (!modal || !user) {
    return null
  }

  const { title, subTitle, searchParams, description } = getData({ userId: user.id, modal })

  const handleClick = (social: SocialType) => {
    const link = getLink({ searchParams, type: modal.type, social })
    window.open(link)
  }

  return (
    <Dialog size="xs" open={Boolean(modal)} handler={() => useStore.setShowModal(null)}>
      <div className="py-4 px-8">
        <DialogHeader style={{ justifyContent: 'center' }}>{title}</DialogHeader>
        <DialogBody className="flex flex-col gap-4">
          <p className="text-gray-600 text-center">{description}</p>
          <div className="grid grid-cols-2 gap-4">
            <IconButton onSubmit={() => handleClick('tg')} title="Telegram" icon="telegramLogo" />
            <IconButton onSubmit={() => handleClick('max')} title="Max" icon="maxLogo" />
          </div>
          <p className="text-gray-600 text-sm text-center">{subTitle}</p>
        </DialogBody>
      </div>
    </Dialog>
  )
})
